import { memo } from "react";
import arrowIcon from "../../../assets/images/arrow.svg";
import LanguageMessage from "../../LanguageMessage/LanguageMessage";
import "./Button.css";
const Button = ({ setStep, step, text, back }) => {
  return (
    <button
      className={`${
        back ? "back flex-row-reverse" : "next"
      }  d-flex align-items-center justify-content-between `}
      onClick={() => setStep(back ? --step : ++step)}
    >
      <span>
        <LanguageMessage message={text} />
      </span>
      <div className="h-100 bg-primary transition" />
      <img
        src={arrowIcon}
        alt="arrow.svg"
        width={30}
        height={30}
        draggable={false}
      />
    </button>
  );
};
export default memo(Button);
